// () => baseChecksMet && (isPreEligible || skipPreEligibility),

/**
 * Get the base access for the cancellation journey.
 * @param baseChecksMet - Whether the base checks are met.
 * @param skipPreEligibility - Whether to skip pre-eligibility checks - we bypass errors due to further checks in the flow.
 * @param isPreEligible - Whether the user is pre-eligible.
 * @returns Whether the user has base access.
 */
export const getCancellationBaseAccess = (
	baseChecksMet: boolean,
	skipPreEligibility: boolean,
	isPreEligible: boolean,
) => {
	if (skipPreEligibility) return baseChecksMet;
	return baseChecksMet && isPreEligible;
};
